import React from 'react';
import classNames from 'classnames';

import { useField } from '../hooks/useField';

import styles from './ErrorMessage.module.scss';

function ErrorMessage({
  name,
  additionalClass,
}: {
  name: string;
  additionalClass?: string;
}): JSX.Element {
  const [, { touched, error: formikError, apiError }] = useField(name);

  const error = formikError && touched ? formikError : apiError || undefined;

  if (error) {
    return (
      <div className={classNames(styles.errorMessage, additionalClass)}>
        {error}
      </div>
    );
  }

  return <></>;
}

export default ErrorMessage;
